/* istanbul ignore file */
import React from 'react';
import { Box, Drawer, Toolbar } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Loading } from './Loading';
import PanelMotion from './PanelMotion';
import { getStyles } from './styles';

export const appBarHeight = 64;
export const drawerWidths = {
  xl: 520,
  md: 320,
};

interface BasePanelProps {
  children: React.ReactNode;
  loading?: boolean;
}

export default function BasePanel({ children, loading }: BasePanelProps) {
  const theme = useTheme();
  const styles = getStyles(theme);

  return (
    <PanelMotion>
      <Drawer
        slotProps={{ paper: { elevation: 4 } }}
        variant='permanent'
        sx={{
          '& .MuiDrawer-paper': styles.drawerPaper,
          '& .MuiDrawer-paperAnchorDockedLeft': styles.drawerPaperAnchorDockedLeft,
        }}
        data-testid='panel-container'
      >
        {/* Spacer Toolbar to ensure the content renders under the top nav */}
        <Toolbar />
        <Box sx={styles.drawerChild}>
          {loading ? <Loading size={50} height='500px' /> : children}
        </Box>
      </Drawer>
    </PanelMotion>
  );
}